<template>
    <section id="control-button">
        <div class="modal" v-bind:class="{ 'is-active': this.isErrorModalActive}">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">กรุณากรอกฟอร์มให้ครบ</p>
                    <button class="delete" aria-label="close"
                            @click="() => this.isErrorModalActive = !this.isErrorModalActive"></button>
                </header>
                <section class="modal-card-body">
                    <ul v-for="item in error" :key="item.id">
                        <li>- {{ item }}</li>
                    </ul>
                </section>
            </div>
        </div>
        <div class="field is-grouped">
            <p class="control">
                <a class="button is-primary" @click="onSubmit">
                    Confirm
                </a>
            </p>
            <p class="control">
                <a class="button is-link" @click="onSaveForm">
                    Save changes
                </a>
            </p>
            <p class="control">
                <a class="button is-danger" @click="onLogOut">
                    Logout
                </a>
            </p>
        </div>
    </section>
</template>

<script>
    import {updateUserData} from "@/firebaseUtil/firestoreUtil";
    import {uploadPhoto} from "@/firebaseUtil/storageUtil";
    import {errorText} from "@/model";

    export default {
        name: "ControlButton",
        data() {
            return {
                isErrorModalActive: false,
                error: []
            }
        },
        computed: {
            // error () {
            //     // return this.$store.getters.error;
            // }
        },
        methods: {
            async onSaveForm() {
                const userId = this.$store.getters.user.uid;
                const profilePhoto = this.$store.getters.userProfilePhoto;
                const storyPhoto = this.$store.getters.userStoryPhoto;

                const uploadResult = await Promise.all([
                    new Promise(resolve => resolve(uploadPhoto('profile', profilePhoto, `${userId}.png`))),
                    new Promise((resolve => resolve(uploadPhoto('story', storyPhoto, `${userId}.png`)))),
                ]);

                const [profilePhotoUrl, storyPhotoUrl] = uploadResult;

                this.$store.dispatch('setUserProfilePhotoUrl', profilePhotoUrl).then(() => {
                    this.$store.dispatch('setUserStoryPhotoUrl', storyPhotoUrl)
                      .then(async () => {
                          return await updateUserData(userId, this.$store.getters.userFormData);
                      });
                    alert('Registration saved');
                });
            },
            async onLogOut() {
                await this.$store.dispatch('logout');
                alert('Log out successful');
                this.$router.replace('login');
            },
            async onSubmit(e) {
                const userForm = await this.$store.getters.userFormData;
                let errors = Object.keys(errorText)
                  .filter(key => key !== null)
                  .map(key => {
                      return userForm[key] === null ? errorText[key] : null
                  })
                  .filter(item => item !== null);
                const hasUploadedProfilePhoto = userForm.profilePhotoUrl !== null;
                const hasUploadedStoryPhoto = userForm.storyPhotoUrl !== null;
                const hasSelectedProfilePhoto = this.$store.getters.userProfilePhoto !== null;
                const hasSelectedStoryPhoto = this.$store.getters.userStoryPhoto !== null;

                if (!hasUploadedProfilePhoto || !hasUploadedStoryPhoto) {
                    if (!hasUploadedProfilePhoto && !hasSelectedProfilePhoto) {
                        errors.push('กรุณาอัพเลือกรูปโปรไฟล์');
                    }

                    if (!hasUploadedStoryPhoto && !hasSelectedStoryPhoto) {
                        errors.push('กรุณาอัพโหลดรูปภาพเรื่องที่เเต่ง')
                    }
                }

                if (errors.length === 0) {
                    const userId = this.$store.getters.user.uid;
                    const profilePhoto = this.$store.getters.userProfilePhoto;
                    const storyPhoto = this.$store.getters.userStoryPhoto;

                    const profilePhotoUrl = hasSelectedProfilePhoto && !hasUploadedProfilePhoto ?
                      await (new Promise(resolve => resolve(uploadPhoto('profile', profilePhoto, `${userId}.png`)))) :
                      userForm.profilePhotoUrl;
                    const storyPhotoUrl = hasSelectedStoryPhoto && !hasUploadedStoryPhoto ?
                      await (new Promise((resolve => resolve(uploadPhoto('story', storyPhoto, `${userId}.png`))))) :
                      userForm.storyPhotoUrl;

                    this.$store.dispatch('setUserProfilePhotoUrl', profilePhotoUrl).then(() => {
                        this.$store.dispatch('setUserStoryPhotoUrl', storyPhotoUrl).then(async () => {
                            const confirmedForm = {
                                ...(this.$store.getters.userFormData),
                                confirmed: true
                            };
                            await this.$store.dispatch('setUserFormData', confirmedForm);
                            return await updateUserData(userId, confirmedForm);
                        })
                    });
                    return true;
                } else {
                    // await this.$store.dispatch('setFormError', errors);
                    // alert('กรุณากรอกฟอร์มให้ครบ');
                    this.error = errors;
                    this.isErrorModalActive = true;
                }
                e.preventDefault();
            }
        }
    }
</script>

<style scoped>

</style>
